<template>
    <div>
        <div v-if="$root.loading" class="loading">در حال بارگذاری...</div>

        <div :class="['sidebar-cart-mask', (show === true ? 'cart-open' : (show === false ? 'cart-close' : ''))]" @click.prevent="close">
        </div>


        <div :class="['sidebar-cart p-2 shadow border-right', (show === true ? 'cart-open' : (show === false ? 'cart-close' : ''))]">
            <button class="btn btn-sm btn-dark sidebar-cart-btn-close float-right ml-3" @click.prevent="close">
                <i class="fa fa-close"></i>
            </button>
            <h3 class="mt-0">سبد خرید</h3>
            <table class="table table-sm">
                <tr>
                    <th style="width: 50px"></th>
                    <th></th>
                    <th></th>
                    <th style="width: 10%"></th>
                </tr>
                <tr v-if="products.length">
                    <td colspan="2">
                        <button @click.prevent="gotoCart" class="btn btn-success">
                            <i class="fa fa-credit-card ml-1"></i>
                            پرداخت
                        </button>
                    </td>
                    <td colspan="2" class="font-weight-bold text-success num-fa text-lg nowrap">
                        {{ total().toLocaleString() }}
                        <span class="mr-1 text-secondary font-weight-normal text-sm">تومان</span>
                    </td>
                </tr>
                <tr v-for="product in products">
                    <td><img width="75" height="54" :src="product.image" class="sidebar-cart-image border"></td>
                    <td class="text-secondary">{{ product.name_fa }}</td>
                    <td class="num-fa font-weight-bold">{{ (product.price - product.discount).toLocaleString() }}</td>
                    <td>
                        <button class="btn btn-sm btn-danger" title="حذف"
                                @click.prevent="remove(product.slug)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'sidebar-cart',
    components: {},
    data() {
        let self = this;

        return {
            show: null,
            products: [],
            related: [],
        };
    },
    props: {},
    computed: {},
    methods: {
        getRelated() {
            let self = this;

            let slugs = [];
            self.products.forEach(function (el) {
                slugs.push(el.slug);
            });
            axios.get(this.$root.baseURL + 'api/v1/related-products/', {params: {slugs: slugs}})
                .then((response) => {
                    self.related = response.data;
                });
        },
        add(productSlug) {
            let self = this;

            self.open();
            self.$root.loading = true;
            axios.get(this.$root.baseURL + 'api/v1/products/' + productSlug)
                .then((response) => {
                    self.$root.loading = false;

                    let found = self.products.find(function (el) {
                        return el.slug === response.data.slug;
                    });

                    if (!found) {
                        self.products.push(response.data);
                        self.writeState();
                        self.$root.toastr.success('به سبد خرید افزوده شد');
                    } else {
                        self.$root.toastr.info('قبلا به سبد افزوده شده!');
                    }
                })
                .catch((error) => {
                    self.$root.onError(error);
                });
        },
        remove(productSlug) {
            let self = this;

            let found = self.products.find(function (el) {
                return el.slug === productSlug;
            });

            if (found) {
                self.products.splice(self.products.indexOf(found), 1);
                self.writeState();
            }
        },
        writeState() {
            localStorage.setItem('cart', JSON.stringify(this.products));
        },
        readState() {
            let st = JSON.parse(localStorage.getItem('cart'));
            if (st) {
                this.products = st;
            }
        },
        total() {
            let result = 0;

            this.products.forEach(function (el) {
                result = result + el.price - el.discount;
            });

            return result;
        },
        amount() {
            let result = 0;

            this.products.forEach(function (el) {
                result = result + el.price;
            });

            return result;
        },
        discount() {
            let result = 0;

            this.products.forEach(function (el) {
                result = result + el.discount;
            });

            return result;
        },
        open() {
            this.show = true;
        },
        close(e) {
            this.show = false;
        },
        gotoCart() {
            window.location = this.$root.baseURL + 'cart';
        }
    },
    mounted() {
        this.$root.cart = this;
        this.readState();
    }
}
</script>
